import { map, split, trim } from 'lodash'
import React, { ReactChild, ReactNode } from 'react'

import { TInputTagHTML } from './types'

export const defaultPasteSplit = (data: string): string[] =>
  map(split(data, ' '), (d) => trim(d))

export const allSeparatorForPasteSplit = (data: string): string[] => {
  const separators = [
    ',',
    ';',
    '\\(',
    '\\)',
    '\\*',
    '/',
    ':',
    '\\?',
    '\n',
    '\r',
  ]
  return data.split(new RegExp(separators.join('|'))).map((d) => d.trim())
}

export const defaultRenderInput = (props: TInputTagHTML): ReactNode => {
  const { onChange, value, addTag, ...other } = props
  return <input type="text" onChange={onChange} value={value} {...other} />
}

export const defaultRenderLayout = (
  tagComponents: ReactNode,
  inputComponent: ReactNode,
): ReactChild => (
  <span>
    {tagComponents}
    {inputComponent}
  </span>
)
